import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12f58aff"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modalBackdrop flex absolute z-max" }
const _hoisted_2 = { class: "c4c-modal" }
const _hoisted_3 = { class: "panelheader" }
const _hoisted_4 = { class: "headerTitleContainer" }
const _hoisted_5 = { class: "headerActions" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "headerTitle" }, "Manage Census  ", -1))
const _hoisted_7 = { "aria-hidden": "true" }
const _hoisted_8 = { class: "neu-tooltip--text tooltipTxt" }
const _hoisted_9 = { "aria-hidden": "true" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "neu-tooltip--text" }, "Close", -1))
const _hoisted_11 = {
  id: "manageCensusModal",
  class: "panleBody scrollBar border",
  style: {"overflow":"scroll"}
}
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Current", -1))
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Activity Log", -1))
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Census Trend", -1))
const _hoisted_16 = {
  key: 0,
  id: "currentCensusTabWrapper",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}
const _hoisted_17 = {
  key: 1,
  id: "activityLogTabWrapper",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}
const _hoisted_18 = {
  id: "trendTabWrapper",
  class: "panelTabData scrollBar",
  role: "tabpanel"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _component_neu_tab = _resolveComponent("neu-tab")!
  const _component_neu_tablist = _resolveComponent("neu-tablist")!
  const _component_CurrentCensusTab = _resolveComponent("CurrentCensusTab")!
  const _component_ActivityLogTab = _resolveComponent("ActivityLogTab")!
  const _component_CensusTrendTab = _resolveComponent("CensusTrendTab")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("header", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            (_ctx.isShowTrainingLink && _ctx.profileData.TrainingEnabled)
              ? (_openBlock(), _createElementBlock("a", {
                  key: 0,
                  href: "#",
                  class: "modaltoolbarIcon neu-tooltip",
                  style: {"cursor":"pointer","color":"#3673AA","text-align":"left"},
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.fnOpenVideo && _ctx.fnOpenVideo(...args)))
                }, [
                  _createElementVNode("span", _hoisted_7, [
                    _createVNode(_component_font_awesome_icon, {
                      icon: ['fas', 'fa-video'],
                      size: "lg"
                    }),
                    _createTextVNode(" Learn How ")
                  ]),
                  _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.trainingLinkToolTip), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("a", {
          href: "#",
          class: "closeBtn neu-tooltip",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
        }, [
          _createElementVNode("i", _hoisted_9, [
            _createVNode(_component_font_awesome_icon, {
              icon: ['fas', 'close'],
              size: "lg"
            })
          ]),
          _hoisted_10
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        (_ctx.isShowTabList)
          ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
              _createVNode(_component_neu_tablist, {
                value: _ctx.selectedTab,
                class: "mx-4 tabList"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_neu_tab, {
                    white: "",
                    tab: "Current",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setSelectedTab('Current')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_13
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_neu_tab, {
                    white: "",
                    tab: "ActivityLog",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.setSelectedTab('ActivityLog')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_14
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_neu_tab, {
                    white: "",
                    tab: "CenusTrend",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setSelectedTab('CensusTrend')))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_15
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["value"]),
              (_ctx.isCurrentTab)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createVNode(_component_CurrentCensusTab, { currentCensusTabInput: _ctx.tabInput }, null, 8, ["currentCensusTabInput"])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.isActivityLogTab)
                ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                    _createVNode(_component_ActivityLogTab, { activityLogTabInput: _ctx.tabInput }, null, 8, ["activityLogTabInput"])
                  ]))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("div", _hoisted_18, [
                _createVNode(_component_CensusTrendTab, { censusTrendTabInput: _ctx.tabInput }, null, 8, ["censusTrendTabInput"])
              ], 512), [
                [_vShow, _ctx.isCensusTrendTab]
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}